import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import { Typography } from "@vc-workspace/utils-typography";
import { containerStyles, contentGridContainer, contentGridItemContainer, contentGridItemImage, prevNavStyles, nextNavStyles } from './maker-meet-seller.module.style';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
export function MakerMeetSeller(props) {
  return _jsxs("div", {
    css: containerStyles,
    children: [_jsx(Typography, {
      type: props.context.isMobileView ? "Headline_H1" : "Heading2",
      color: "heavy_metal",
      className: "text-center",
      bold: true,
      children: "Creative Seller love us!"
    }), _jsx("div", {
      className: props.context.isMobileView ? "" : "page-container",
      children: !props.context.isMobileView ? _jsxs(CarouselProvider, {
        naturalSlideWidth: 200,
        naturalSlideHeight: 300,
        visibleSlides: 4,
        infinite: true,
        totalSlides: 8,
        css: contentGridContainer,
        children: [_jsx(Slider, {
          style: {
            height: 'inherit'
          },
          children: SellerData.map(function (item, index) {
            return _jsx(Slide, {
              index: index,
              children: _jsxs("div", {
                css: contentGridItemContainer,
                children: [_jsx("picture", {
                  children: _jsx("img", {
                    src: item.url,
                    css: contentGridItemImage
                  })
                }), _jsxs(Typography, {
                  type: "Body2",
                  color: "night_rider",
                  className: "pt-4 text-justify whitespace-normal",
                  children: [_jsxs("strong", {
                    children: [item.name, ","]
                  }), " ", item.description]
                })]
              }, item.name)
            }, item.name);
          })
        }), _jsx(ButtonBack, {
          children: _jsx("div", {
            css: prevNavStyles,
            children: _jsx(ChevronLeftIcon, {})
          })
        }), _jsx(ButtonNext, {
          children: _jsx("div", {
            css: nextNavStyles,
            children: _jsx(ChevronRightIcon, {})
          })
        })]
      }) : _jsx("div", {
        css: contentGridContainer,
        children: SellerData.map(function (item) {
          return _jsxs("div", {
            css: contentGridItemContainer,
            children: [_jsx("picture", {
              children: _jsx("img", {
                src: item.url,
                css: contentGridItemImage
              })
            }), _jsxs(Typography, {
              type: "Body2",
              color: "night_rider",
              className: "pt-4 text-justify whitespace-normal",
              children: [_jsxs("strong", {
                children: [item.name, ","]
              }), " ", item.description]
            })]
          }, item.name);
        })
      })
    })]
  });
}
;
var SellerData = [{
  url: '/_mp-images/brands/Gir.jpg',
  name: 'Girnatives',
  description: 'Vibecity is a very good platform to promote our A2 Cow products. It is easy to use and has made collecting payments a lot smoother. The customer support is also very good and prompt - they are ready to help anytime.'
}, {
  url: '/_mp-images/brands/Akshaa.jpg',
  name: 'Akshaa Nature',
  description: 'Very happy to be working with Vibecity. It gives a very easy platform for my customers to buy products and collect payments without delay.'
}, {
  url: '/_mp-images/brands/BBV.jpeg',
  name: 'Baked Brown by Viya',
  description: 'I am totally loving this app. It is giving us great opportunities and also exposure to all small business owners. This app is very helpful to me thanks a lot 🤎🍪'
}, {
  url: '/_mp-images/brands/Maanushi.png',
  name: 'Maanushi Foundation',
  description: 'My experience with Vibecity has been exceptional. The app is very userfriendly, one can easily list their products on the app and build an ecommerce website. There is round the clock tech support as well. The payments are also very regular. The only glitch I have come across is the app not loading at times, but once I reached out to the team, they immediately resolved the same.'
}, {
  url: '/_mp-images/brands/Sattwa.png',
  name: 'Sattwa Studio',
  description: 'A wonderful platform for Homegrown brands and Artisans. As a seller there myself, I highly recommend this platform to small business owners like me. Design and ease of use are two highlights of this platform. Not to mention about the passionate team working behind it. Thank you so much Vibecity.'
}, {
  url: '/_mp-images/brands/360Organic.png',
  name: '360 Organic',
  description: 'Vibecity is a great platform for small business owners. Provides opportunities for home based small businesses for growing. Showcasing our products has become hassle free. Team is also friendly. Thank you for this platform! Great going😊'
}, {
  url: '/_mp-images/brands/Dhaagina.png',
  name: 'Dhaagina',
  description: 'Being a small business, Vibecity has given me a chance to grow with the amazing setup done by them for my personalized website. Now, the process has become seamless and saves a lot of time. Thanks Team Vibecity. This really means a lot to my small business.'
}, {
  url: '/_mp-images/brands/EcoNation.png',
  name: 'Handmade Soaps By Eco-nation',
  description: 'As a seller on Vibecity, I really liked the concept of providing a platform to handmade small businesses and helping us to expand hassle free. And a special thanks to Anusha for introducing us to this unique concept! Vibecity is doing really great for us. The team of Vibecity, especially Prag, is taking every possible effort to give us all the information we need to develop a great online store! Thankyou ♥️'
}];
export default MakerMeetSeller;